import {FormField} from 'platform/components';
import {z} from 'zod';

import {useGetSalePresetSettingsListQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {BulkOperationForm, type BulkOperationActionCallbackParams} from 'features/eag-grid';

const VehicleSalesProgramBulkFormSchema = z.object({salePresetId: z.string().uuid()});

export function VehicleSalesProgramBulkForm(props: {action: BulkOperationActionCallbackParams}) {
  const {currentData: presets = [], isFetching, isError} = useGetSalePresetSettingsListQuery();
  return (
    <BulkOperationForm
      action={props.action}
      onError={handleApiError}
      experimentalZodSchema={VehicleSalesProgramBulkFormSchema}
      defaultValues={{salePresetId: ''}}
      isDisabled={isFetching || isError}
      toParams={(values) => values}
    >
      {(control) => (
        <FormField
          type="choice"
          control={control}
          name="salePresetId"
          label={i18n.t('entity.vehicle.labels.salesProgram')}
          options={presets.map((preset) => ({value: preset.id, label: preset.name}))}
          isLoading={isFetching}
          menuInPortal
          isRequired
        />
      )}
    </BulkOperationForm>
  );
}
